import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const dividerHeight = 14;
export const Container = styled.div`
    display: block;
    flex: 1;
    padding: 0 16px 0 12px;
    color: ${props => props.theme.colors[props.theme.colorMode].text_High_Emphasis};
    vertical-align: middle;
`;

export const TruncatedText = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    outline: 0;
    white-space: nowrap;
`;

export const NameWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const InlineBalanceContainer = styled.div`
    display: flex;

    :before {
        content: "";
        border: 1px solid ${props => props.theme.colors.light.divider};
        height: ${dividerHeight}px;
        margin-right: 8px;
        margin-left: 6px;
        border-radius: 10px;
    }
`;

export const BalanceValueContainer = styled.div`
    display: flex;
    :before {
        content: "\u20B9";
        margin-left: 4px;
    }
`;

export const BalanceText = styled(Text)`
    margin-top: 1px;
`;
